import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReferenceDataLabels, ReferenceDataService, RomeNotificationService, ValidationError } from 'rome-library';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class NotificationsInterceptor implements HttpInterceptor {
  private readonly successfulNotifications = new Map<string, string>([
    ['/Emails/resendUserConfirmationRequestEmail', ReferenceDataLabels.EmailResent],
    ['/Applications/SaveApplication', ReferenceDataLabels.NotificationSaveSuccess]
  ]);

  private readonly errorNotifications = new Map<string, string>([
    ['/addresses/getAddresses', ReferenceDataLabels.NoAddressesFound],
    ['/Applications/SaveApplication', ReferenceDataLabels.NotificationValidationErrors]
  ]);
  private readonly hiddenErrorsEndpoints = [
    'CaseManagement/SubmitKfi',
    'CaseManagement/CreateKfi',
    'CaseManagement/ValidateKfi',
    'productPicker/GetProduct',
    'Agents/sendResetForgottenPasswordRequest',
    'DirectCustomer/sendResetForgottenPasswordRequest',
    'MortgageOfferManagement/RetrieveOfferValidityStatus',
    'ExternalAgents/RegisterAgentFromExternal',
    'Agents/securityQuestionForPasswordResetRequest',
    'DirectCustomer/securityQuestionForPasswordResetRequest'
  ];

  constructor(
    private readonly notificationService: RomeNotificationService,
    private readonly referenceDataService: ReferenceDataService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(
        (event) => {
          if (event instanceof HttpResponse) {
            const businessValidationErrors = event?.body?.ValidationErrors?.BusinessValidationErrors;
            const hasBusinessValidationErrors = businessValidationErrors
              ? Object.keys(businessValidationErrors).length > 1
              : false;
            const notification = !hasBusinessValidationErrors
              ? this.successfulNotifications.get(req.url)
              : this.errorNotifications.get(req.url);

            if (notification) {
              const message = this.referenceDataService.getLocalizeLabel(notification);
              if (!hasBusinessValidationErrors) {
                this.notificationService.showSuccess(message);
              } else {
                this.notificationService.showError(message);
              }
            }
          }
        },
        (error) => {
          if (error instanceof HttpErrorResponse && error.error) {
            if (
              this.hiddenErrorsEndpoints.some((endpoint) => req.url.toLowerCase().indexOf(endpoint.toLowerCase()) > -1)
            ) {
              return;
            }
            const httpErrorResponseMessage =
              req.responseType === 'text' ? JSON.parse(error.error).Message : error.error.Message;
            const notification = this.errorNotifications.get(req.url);

            let messageToBeDisplayed = notification
              ? this.referenceDataService.getLocalizeLabel(notification)
              : this.referenceDataService.getLocalizeLabel(httpErrorResponseMessage);

            if (!messageToBeDisplayed) {
              messageToBeDisplayed = httpErrorResponseMessage;
              try {
                const json = JSON.parse(messageToBeDisplayed);
                const validationError = new ValidationError(undefined, json.Name, json.Code, new Array<string>());
                messageToBeDisplayed = this.referenceDataService.getLocalizeErrorMessage(validationError);
              } catch (e) {}
            }

            this.notificationService.showError(messageToBeDisplayed);
          }
        }
      )
    );
  }
}
